module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/3f9cf4ad57c870d5772d62f885d1ae23.png";